<ub-card variant="primary" [dividers]="false" [flat]="true">
  <h4 title >
    {{ READABLE_CREDENTIAL_TYPES[credential.type] }}
    @if (credential.type !== CredentialTypes.API) {
      <span>: {{ credential.username }}</span>
    }
    @if (credential.type === CredentialTypes.API) {
      <span>: {{ credential.public_key }}</span>
    }
  </h4>
</ub-card>
